var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1a15 15 0 100 30 15 15 0 000-30zm0 28a13 13 0 110-25.999A13 13 0 0116 29z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.46V6a1 1 0 10-2 0v10.09a1.193 1.193 0 000 .2c.02.062.043.122.07.18.03.052.064.102.1.15l.15.15.07.06 6 4A.94.94 0 0022 21a1 1 0 00.55-1.83L17 15.46z"
  })));
}

export default SvgClock;